import { SearchX } from 'lucide-react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

export function NotFoundFallback() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4" role="alert">
      <SearchX className={'size-16 text-red-500'} />
      <h2 className="text-lg font-semibold">Ooops, den här sidan finns inte 🤔</h2>
      <Button asChild>
        <Link to={'/'}>Gå hem</Link>
      </Button>
    </div>
  );
}
